<template>
  <div class="warning-forecast-container" v-loading="isLoading">
    <div class="warning-title">
      <el-form :inline="true" :model="reqParams" size="mini" label-width="120px" class="search-params-form">
        <el-form-item label="预测状态">
          <el-select v-model="reqParams.predictionState">
            <el-option v-for="item in predictionStateList" :key="item.value" :label="item.summary" :value="item.value"></el-option>
            <el-option label="全部" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="站点名称">
          <el-input placeholder="站点名称" v-model="reqParams.stationName" size="mini" clearable></el-input>
        </el-form-item>

        <el-form-item label=" " class="no-label">
          <div class="search-button">
            <el-button type="primary" @click="onSearch">查询</el-button>
          </div>
          <el-button @click="onResetReqParams">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <i class="last-modifiedtime-tips">
      <em class="data-picker-container fl">
        <button class="date-picker fl" @click="onPreOrNextPageClick(false)" :disabled="disablePrePageBtn ? 'disabled' : false">前{{TABLE_DAY_COUNT_PER_PAGE}}天</button>
        <button class="date-picker fr" @click="onPreOrNextPageClick(true)" :disabled="disableNextPageBtn ? 'disabled' : false">后{{TABLE_DAY_COUNT_PER_PAGE}}天</button>
      </em>
      <div class="warning-tips fr">
        <div class="normal quick-operation" @click="quickSearch(1)">
          <i class="warning-box  warning-forecast-normal"></i>{{plotState.notSatisfied}}个站点不会出现
        </div>
        <div class="close quick-operation" @click="quickSearch(2)">
          <i class="warning-box warning-forecast-close"></i>{{plotState.closeToSatisfy}}个站点接近
        </div>
        <div class="achieve quick-operation" @click="quickSearch(3)">
          <i class="warning-box warning-forecast-achieve"></i>{{plotState.satisfied}}个站点达到
        </div>
      </div>
    </i>
    <!-- <div v-for="plot in plotList" :key="plot.stationID"> -->
      <!-- <div class="warning-plot-location">
        <div class="location-title" v-if="plot">
          <div class="plot-name">站点名称：{{plot.stationName}}</div>
          <div class="plot-location">站点位置：{{plot.fullAddress}}</div>
          <div class="plot-longitude">经度：{{plot.longitude}}</div>
          <div class="plot-latitude">纬度：{{plot.latitude}}</div>
        </div>
      </div> -->
      <div class="warning-main">
        <div class="warning-main-table">
          <el-table
            height="100%"
            :data="tableDataList"
            border
            size="mini"
            :cell-style="changeCellStyle"
            :span-method="mergeCells"
            :header-cell-style="tableHeaderStyle"
            ref="table">
            <el-table-column
              fixed
              label="序号"
              min-width="50"
              align="center"
              property="showIndex">
            </el-table-column>
            <el-table-column
              label="站点"
              fixed
              min-width="100"
              align="center">
              <template slot-scope="scope">
                <div>{{scope.row.stationName}}</div>
                <el-button v-if="scope.row.hasJYWeatherStation"
                           type="primary"
                           plain
                           round
                           size="mini"
                           style="margin-top:20px;width:85px;height:48px;white-space:normal!important;"
                           @click="goJYWeatherStationPage(scope.row.stationID, scope.row.stationName)">
                  查看植塔气象数据
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item,index) in tableHeaderRow"
              :key="index"
              :label="item.label"
              :fixed="index === 0"
              align="center"
              :width="item.width"
              :property="item.property">
            </el-table-column>
            <el-table-column
              label="历史120小时降雨量"
              min-width="80"
              align="center">
              <el-table-column
                label="时间"
                min-width="180"
                align="center"
                property="sumPrecipitation120hLabel">
              </el-table-column>
              <el-table-column
                label="降雨量"
                min-width="80"
                align="center"
                property="sumPrecipitation120h">
              </el-table-column>
            </el-table-column>
             <el-table-column label="中心病株预测结果" align="center" width="190">
              <template slot-scope="scope">
                <div class="warning-main-confirm" v-if="scope.row.sumPrecipitation120hLabel || scope.row.sumPrecipitation120h">
                  <el-button type="text" :disabled="scope.row.stationState == 2 || scope.row.stationState == 3" :class="[{'warning-forecast-normal-text': scope.row.state == 1}]" @click="onConfirmState(1, scope.row)">不会出现</el-button>
                  <el-button type="text" :disabled="scope.row.stationState == 2 || scope.row.stationState == 3" :class="[{'warning-forecast-close-text': scope.row.state == 2}]" @click="onConfirmState(2, scope.row)">接近</el-button>
                  <el-button type="text" :disabled="scope.row.stationState == 3" :class="[{'warning-forecast-achieve-text': scope.row.state == 3}]" @click="onConfirmState(3, scope.row)">达到</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { getRequest, putRequest } from 'utils/http-service'
import { URL_LATEBLIGHT_PAGE, URL_LATEBLIGHT_PREDICTION_STATE, URL_LATEBLIGHT_WEATHER_INDICATORS } from '../../constants/url'
import { NOT_SATISFIED, CLOSE_TO_SATISFY, SATISFIED, MILLISECONDS_PER_DAY } from '../../constants/constants'
import { DiseasedStrainStateEnum } from 'utils/DiseasedStrainStateEnum'
import eventBus from '../../utils/EventBus'

export default {
  name: 'warningForecast',

  data () {
    return {
      plotState: {
        notSatisfied: 0,
        closeToSatisfy: 0,
        satisfied: 0
      },
      plotList: [],
      airAndSoilDataMap4CropsRplotID: {},
      isLoading: false,
      reqParams: {
        predictionState: '',
        stationName: ''
      },
      startTimestamp: '',
      predictionStateList: [],
      tableDataList: [],

      /* 以下是表格相关的变量 */
      tableHeaderRow: [], // { label, property }, label是首行表头标签，property是该列数据的key
      TABLE_ROW_TITLE_COLUMN: 0, // 表格的行标题所在的列号，0-plotd
      TABLE_DAILY_DATA_START_COLUMN: 1, // 表格的每日数据开始的列号，0-plotd
      TABLE_DAY_COUNT_PER_PAGE: 12,
      disablePrePageBtn: true,
      disableNextPageBtn: true,
      tableRowNode4Merge: [] // 行的合并规则, 从startRowIndex开始，合并needTobeMergedRowCount行
    }
  },

  methods: {
    mergeCells ({ row, column, rowIndex, columnIndex }) {
      let isMerge = false
      let mergeCount = 0

      if (columnIndex === 0 || columnIndex === 1) {
        for (let i = 0; i < this.tableRowNode4Merge.length; i++) {
          let item = this.tableRowNode4Merge[i]

          if (rowIndex === item.startRowIndex) {
            isMerge = true
            mergeCount = item.needTobeMergedRowCount
            break
          }
        }

        if (isMerge) {
          return [mergeCount, 1]
        } else {
          return [0, 0]
        }
      }
    },

    changeCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 0) {
        if (rowIndex === 0 && columnIndex === 13) {
          return {'background-color': '#cfd5ea'}
        }
        return {'background-color': '#cfd5ea'}
      } else {
        return {'background-color': '#e9e8f5'}
      }
    },

    tableHeaderStyle ({ row, column, rowIndex, columnIndex }) {
      // if (rowIndex === 1) {
      //   return {display: 'none'}
      // }
    },

    onSearch () {
      let that = this
      that.isLoading = true
      that._processTableData()
      that.isLoading = false
    },

    onResetReqParams () {
      let that = this
      that.isLoading = true
      that.reqParams.predictionState = ''
      that.reqParams.stationName = ''
      that._processTableData()
      that.isLoading = false
    },

    quickSearch (state) {
      if (state === this.reqParams.predictionState) {
        this.onResetReqParams()
      } else {
        this.reqParams.predictionState = state
        this.onSearch()
      }
    },

    goJYWeatherStationPage (stationID, stationName) {
      let tableDom = this.$refs.table.bodyWrapper
      let scrollTop = tableDom.scrollTop

      this.$router.push({
        name: 'jy-weather-station',
        params: {
          stationID: stationID,
          stationName: stationName,
          scrollTop: scrollTop
        }
      })
    },

    onConfirmState (state, currentStation) {
      let stateName = DiseasedStrainStateEnum.getEnumByValue(state)
      let currentStationStateName = DiseasedStrainStateEnum.getEnumByValue(currentStation.stationState)
      let content = ''

      if (currentStation.stationState === DiseasedStrainStateEnum.UNPREDICTED.value) {
        content = `您确认要将${currentStation.stationName}站点预测为 ${stateName.summary} 吗？`
      } else {
        content = `您确认要将${currentStation.stationName}站点的预测结果由 ${currentStationStateName.summary} 更改为 ${stateName.summary} 吗？`
      }

      this.$confirm(content, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateWarningState(state, stateName, currentStation)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消判定',
          offset: 300
        })
      })
    },

    updateWarningState (state, stateName, currentStation) {
      this.isLoading = true

      putRequest(URL_LATEBLIGHT_PREDICTION_STATE + `/${currentStation.predictionID}`, {
        state: state,
        endTimestamp: currentStation.sumPrecipitation120hLabel.indexOf('最近') > -1 ? new Date().getTime() : currentStation.endTimestamp
      }).then(res => {
        this.isLoading = false
        if (res.code === 0 || res.success) {
          this.plotList.some((plotItem, index) => {
            if (plotItem.stationID === currentStation.stationID) {
              let currentState = plotItem.diseasedStrainState.summaryEn
              this.plotState[currentState]--
              this.plotState[stateName.summaryEn]++
              plotItem.diseasedStrainState = stateName
              plotItem.state = state
              // plotItem.checkDate = (new Date()).getTime()
              plotItem.sumPrecipitationHistory120hList.some(e => {
                if (e.endTimestamp === currentStation.endTimestamp) {
                  e.state = state
                  return true
                }
              })

              return true
            }
          })

          this.tableDataList.some((item, index) => {
            if (item.stationID === currentStation.stationID && item.endTimestamp === currentStation.endTimestamp) {
              item.state = state
              this.$set(this.tableDataList[index], 'state', state)
              setTimeout(() => {
                this.tableDataList = [].concat(this.tableDataList)
                this.$refs.table.doLayout()
                this._processTableData()
              }, 10)
              return true
            }
          })

          this.$message({
            type: 'success',
            message: '判定成功!',
            offset: 300
          })
        } else {
          if (res.message.indexOf('Late blight can NOT be changed') !== -1) {
            this.$message.error({
              message: '当前站点中心病株预测结果时间已经超过24小时，预测结果不允许修改！',
              offset: 300
            })
          } else {
            this.$message.error({
              message: '判定失败!',
              offset: 300
            })
          }
          console.error(this.$route.name + ' updateWarningState err:' + res.message)
        }
      }).catch(err => {
        this.isLoading = false
        console.error(this.$route.name + ' updateWarningState err:' + err)
        this.$message.error({
          message: '判定失败!',
          offset: 300
        })
      })
    },

    onPreOrNextPageClick (gotoNext) {
      if (this.isLoading) {
        return
      }

      let dstPageStartDate = this.startTimestamp +
        this.TABLE_DAY_COUNT_PER_PAGE * MILLISECONDS_PER_DAY * (gotoNext ? 1 : -1)

      this.startTimestamp = dstPageStartDate
      this._setPreOrNextBtnDisableState(dstPageStartDate)
      this._setColumnLabel(dstPageStartDate)
      this._getAndShowPlotAirSoilData(dstPageStartDate)
    },

    // 设置表格每列的property
    _setColumnProperty () {
      let tableHeaderRow = []
      tableHeaderRow[this.TABLE_ROW_TITLE_COLUMN] = { label: '', property: 'rowLabel' }
      for (let i = 0; i < this.TABLE_DAY_COUNT_PER_PAGE; i++) {
        tableHeaderRow[this.TABLE_DAILY_DATA_START_COLUMN + i] =
          { label: '', width: '72', property: 'day' + i + 'Value' }
      }
      this.tableHeaderRow = tableHeaderRow
    },

    getPlotListInfo () {
      getRequest(URL_LATEBLIGHT_PAGE)
        .then(res => {
          let plotListInfo = this._transformPlotInfoData(res.data)
          this.plotList = plotListInfo.plotList
          this.plotState.notSatisfied = plotListInfo.notSatisfiedCount
          this.plotState.closeToSatisfy = plotListInfo.closeToSatisfyCount
          this.plotState.satisfied = plotListInfo.satisfiedCount
          this.airAndSoilDataMap4CropsRplotID = plotListInfo.airAndSoilDataMap4CropsRplotID

          if (!Array.isArray(this.plotList) || this.plotList.length === 0) {
            this.$message({
              showClose: true,
              message: '当前没有任何站点信息！',
              offset: 300
            })
            console.warn(this.$route.name + ' getPlotListInfo err: 当前没有任何站点信息！')
            return
          }

          this.getDetailData4Plot()
        })
        .catch(err => {
          console.error(this.$route.name + ' getPlotListInfo err: ', err)
        })
    },

    _transformPlotInfoData (resData) {
      let plotListInfo = {}
      let airAndSoilDataMap4CropsRplotID = {}
      let notSatisfiedCount = 0
      let closeToSatisfyCount = 0
      let satisfiedCount = 0;

      (resData || []).forEach((plotItem, index) => {
        plotItem.stationID = plotItem.weatherStationCode
        plotItem.predictionID = plotItem.pridictionID
        plotItem.stationName = plotItem.weatherStationName
        plotItem.state = plotItem.state
        // plotItem.sumPrecipitation120h = plotItem.sumPrecipitationRecent120h ? plotItem.sumPrecipitationRecent120h / Math.pow(10, 2) : plotItem.sumPrecipitationRecent120h
        plotItem.hasJYWeatherStation = plotItem.adjacentAirIoTDeviceIDs.length > 0
        plotItem.adjacentAirIoTDeviceIDs = plotItem.adjacentAirIoTDeviceIDs
        plotItem.sumPrecipitationHistory120hList = plotItem.sumPrecipitationHistory120hList || []
        // plotItem.checkDate = plotItem.checkTimestamp

        if (plotItem.sumPrecipitationHistory120hList.length > 0) {
          plotItem.sumPrecipitationHistory120hList.some(e => {
            if (e.displaySummary && e.displaySummary.indexOf('最近') > -1) {
              plotItem.sumPrecipitation120h = e.sumPrecipitation ? e.sumPrecipitation / Math.pow(10, 2) : e.sumPrecipitation
              return true
            }
          })

          if (!plotItem.sumPrecipitation120h) {
            plotItem.sumPrecipitation120h = 0
          }
        } else {
          plotItem.sumPrecipitation120h = 0
        }

        // if (plotItem.sumPrecipitation120h) {
        //   plotItem.sumPrecipitation120h += 'mm'
        // }

        if (plotItem.stationID) {
          airAndSoilDataMap4CropsRplotID[plotItem.stationID] = []
        }

        plotItem.diseasedStrainState = DiseasedStrainStateEnum.getEnumByValue(plotItem.state)

        switch (plotItem.state) {
          case NOT_SATISFIED:
            notSatisfiedCount++
            break
          case CLOSE_TO_SATISFY:
            closeToSatisfyCount++
            break
          case SATISFIED:
            satisfiedCount++
            break
        }
      })

      resData.sort((a, b) => b.sumPrecipitation120h - a.sumPrecipitation120h)
      for (let i = 0; i < resData.length; i++) {
        if (resData[i].stationName === '2021 沽源~久恩农业~河北农大5') {
          resData.splice(i, 1)
          break
        }
      }

      plotListInfo.plotList = resData
      plotListInfo.notSatisfiedCount = notSatisfiedCount
      plotListInfo.closeToSatisfyCount = closeToSatisfyCount
      plotListInfo.satisfiedCount = satisfiedCount
      plotListInfo.airAndSoilDataMap4CropsRplotID = airAndSoilDataMap4CropsRplotID

      return plotListInfo
    },

    getDetailData4Plot () {
      let startDate = this._getStartTimestampOfDay(new Date().getTime()) -
        (this.TABLE_DAY_COUNT_PER_PAGE - 1) * MILLISECONDS_PER_DAY // -1 to include today

      this.startTimestamp = startDate
      this._setColumnLabel(startDate)
      this._getAndShowPlotAirSoilData(startDate)
    },

    // 设置表格每列的标题
    _setColumnLabel (startTimestamp) {
      let tableHeaderRow = this.tableHeaderRow
      tableHeaderRow[this.TABLE_ROW_TITLE_COLUMN].label = '时间'

      let date = new Date(startTimestamp)
      for (let i = 0; i < this.TABLE_DAY_COUNT_PER_PAGE; i++) {
        tableHeaderRow[this.TABLE_DAILY_DATA_START_COLUMN + i].label =
          date.getMonth() + 1 + '.' + date.getDate()
        date.setDate(date.getDate() + 1)
      }
      this.tableHeaderRow = tableHeaderRow
    },

    _getAndShowPlotAirSoilData (startDate) {
      this.isLoading = true
      let endTimestamp = startDate + (this.TABLE_DAY_COUNT_PER_PAGE) * MILLISECONDS_PER_DAY - 1000

      getRequest(URL_LATEBLIGHT_WEATHER_INDICATORS, {
        startTimestampIncluded: startDate,
        endTimestampIncluded: endTimestamp
      }).then(res => {
        this.isLoading = false
        if (!res || !res.data) {
          throw Error('数据异常，服务器错误')
        }

        this._transformAirAndSoilDto2Vo(res.data, startDate)
        this._processTableData()
        this._setPreOrNextBtnDisableState(startDate)
      }).catch(err => {
        this.isLoading = false
        console.error(this.$route.name + ' _getAndShowPlotAirSoilData() err:', err)
      })
    },

    _transformAirAndSoilDto2Vo (dto, startDate) {
      let rowTitleColumnProperty = this.tableHeaderRow[this.TABLE_ROW_TITLE_COLUMN].property

      for (let key in this.airAndSoilDataMap4CropsRplotID) {
        this.airAndSoilDataMap4CropsRplotID[key] = []
      }

      try {
        for (let id in dto) {
          let item = dto[id]
          let tableBodyRows = []
          let rowAirTemperature = {}
          let rowAirHumidity = {}
          let rowPrecipitation = {}

          rowAirTemperature[rowTitleColumnProperty] = '空气温度(日平均℃)'
          rowAirHumidity[rowTitleColumnProperty] = '空气湿度(日平均%rh)'
          rowPrecipitation[rowTitleColumnProperty] = '降雨量(日累计mm)'

          for (let i = 0; i < item.length; i++) {
            let dayIndex = this._calculateDiffDayCount(
              item[i].dailyReportTimestamp, startDate, -1, this.TABLE_DAY_COUNT_PER_PAGE)

            let columnProperty = this.tableHeaderRow[dayIndex + this.TABLE_DAILY_DATA_START_COLUMN].property
            rowAirTemperature[columnProperty] = (item[i].dailyAvgAirTemperature) ? (item[i].dailyAvgAirTemperature) / Math.pow(10, 2) : item[i].dailyAvgAirTemperature
            rowAirHumidity[columnProperty] = (item[i].dailyAvgAirHumidity) ? (item[i].dailyAvgAirHumidity) / Math.pow(10, 2) : item[i].dailyAvgAirHumidity
            rowPrecipitation[columnProperty] = (item[i].dailySumPrecipitation) ? (item[i].dailySumPrecipitation) / Math.pow(10, 2) : item[i].dailySumPrecipitation
          }

          tableBodyRows.push(rowAirTemperature, rowAirHumidity, rowPrecipitation)

          this.airAndSoilDataMap4CropsRplotID[id] = tableBodyRows
        }
      } catch (error) {
        console.error(this.$route.name + ' _transformAirAndSoilDto2Vo() err: ', error)
      }
    },

    _processTableData () {
      let tableDataList = []
      let rowTitleColumnProperty = this.tableHeaderRow[this.TABLE_ROW_TITLE_COLUMN].property
      let showIndex = 0
      let tableRowNode4Merge = []
      this.isLoading = true

      this.plotList.forEach((item, index) => {
        if (this.reqParams.predictionState !== '' && item.state !== this.reqParams.predictionState) {
          return
        }

        if (this.reqParams.stationName && item.stationName.indexOf(this.reqParams.stationName) === -1) {
          return
        }

        let arr = JSON.parse(JSON.stringify(this.airAndSoilDataMap4CropsRplotID[item.stationID] || []))

        if (arr.length === 0) {
          arr.push({}, {}, {})
          arr[0][rowTitleColumnProperty] = '空气温度(日平均℃)'
          arr[1][rowTitleColumnProperty] = '空气湿度(日平均%rh)'
          arr[2][rowTitleColumnProperty] = '降雨量(日累计mm)'
        }

        arr[0].hasJYWeatherStation = item.hasJYWeatherStation
        ++showIndex
        arr[0].showIndex = showIndex

        let len = item.sumPrecipitationHistory120hList.length
        if (len > 3) {
          for (;len > 3; len--) {
            arr.push({rowLabel: ''})
          }
        }

        item.sumPrecipitationHistory120hList.forEach((ele, index) => {
          arr[index].stationState = item.state
          arr[index].state = ele.state
          arr[index].sumPrecipitation120hLabel = ele.displaySummary
          arr[index].sumPrecipitation120h = ele.sumPrecipitation ? (ele.sumPrecipitation / Math.pow(10, 2)) + 'mm' : ele.sumPrecipitation
          arr[index].endTimestamp = ele.endTimestamp
          arr[index].predictionID = ele.predicationID
          arr[index].stationName = item.stationName
          arr[index].stationID = item.stationID
        })

        tableRowNode4Merge.push({
          startRowIndex: tableDataList.length,
          needTobeMergedRowCount: arr.length
        })

        tableDataList = tableDataList.concat(arr)
      })
      this.tableDataList = tableDataList
      this.tableRowNode4Merge = tableRowNode4Merge
      this.isLoading = false
    },

    /**
     * 设置 "上一页" 和 "下一页" 按钮是否可点击。
     * 当前页面已有数据时，启用"上一页"按钮。(上一页很难翻到头，暂不考虑左边界)
     * 当前页面已有数据 且 当前页数据的截止时间小于当前日期时，启用"下一页"按钮。
     */
    _setPreOrNextBtnDisableState (startDate) {
      this.disablePrePageBtn = true
      this.disableNextPageBtn = true

      if (this.plotList.length > 0) {
        this.disablePrePageBtn = false

        if (startDate + this.TABLE_DAY_COUNT_PER_PAGE * MILLISECONDS_PER_DAY <
            this._getStartTimestampOfDay(new Date().getTime())) {
          this.disableNextPageBtn = false
        }
      }
    },

    // 获取给定时间戳代表的那一天的初始时刻的时间戳
    _getStartTimestampOfDay (timestamp) {
      let date = new Date()
      date.setTime(timestamp)
      date.setMilliseconds(0)
      date.setSeconds(0)
      date.setMinutes(0)
      date.setHours(0)
      return date.getTime()
    },

    // 计算给定的timestamp距离startTimestamp的天数，向下取整。
    // 如果参数异常，或者相距离天数 <= minLimit 或 >= maxLimit，抛出异常
    _calculateDiffDayCount (timestamp, startTimestamp, minLimit, maxLimit) {
      if (isNaN(timestamp) || isNaN(startTimestamp) ||
          isNaN(minLimit) || isNaN(maxLimit)) {
        throw Error('_calculateDiffDayCount() invalid params')
      }
      let dayCount = Math.floor((timestamp - startTimestamp) / MILLISECONDS_PER_DAY) // 0-plotd
      if (dayCount <= minLimit || dayCount >= maxLimit) {
        throw Error('_calculateDiffDayCount() diff days' + dayCount +
          ' out of range [' + minLimit + ', ' + maxLimit + ']')
      }
      return dayCount
    }
  },

  created () {
    this.isLoading = true
    this.predictionStateList = DiseasedStrainStateEnum.symbols()
    this._setColumnProperty()
    this.getPlotListInfo()
    this.isLoading = false
  },

  activated () {
    eventBus.$on('setTableScrollTop', function (scrollTop) {
      if (scrollTop) {
        setTimeout(() => {
          this.$refs.table.bodyWrapper.scrollTop = scrollTop
        }, 100)
      }
    }.bind(this))
  }

  // deactivated () {
  //   this.$destroy()
  // }
}
</script>

<style lang="less" scoped>
.warning-forecast-container {
  width:100%;
  height:100%;
  display: flex;
  flex-direction: column;
  .warning-title {
    padding-top: 25px;
    padding-right: 40px;
    width: 100%;
    border-bottom: 1px solid #ccc;
    .tips {
      padding: 0 40px 10px;
      border-bottom: 1px solid #ccc;
      span {
        color: rgb(26, 15, 190);
      }
    }
    .search-params-form {
      width: 100%;
      height: 100%;
      .no-label /deep/ .el-form-item__label {
        width: 0!important;
      }
      .large-label /deep/ .el-form-item__label {
        width: 140px!important;
      }
      .search-button {
        display: inline-block;
        margin-right: 70px;
      }
    }
  }
  & > i {
    display: block;
    height: 30px;
    padding: 0 48px;
    margin: 6px 0;
    .warning-tips {
      display: flex;
      justify-content: space-between;
      width: 420px;
      padding-top: 6px;
      font-size: 12px;
      div {
        display: flex;
        align-items: center;
      }
      .quick-operation {
        cursor: pointer;
      }
      .warning-box {
        display: inline-block;
        margin: 0 7px 0;
        width: 22px;
        height: 16px;
        border-radius: 4px;
      }
    }
    &.last-modifiedtime-tips {
      display:block;
      width:100%;
      height:22px;
      font-size:0;
    }
    .data-picker-container {
      display: block;
      width: 140px;
      padding-top: 5px;
      height: 100%;
      button {
        display: block;
        height: 100%;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
  .warning-plot-location {
    width: 100%;
    height: 30px;
    padding: 0 45px;
    .location-title {
      display: flex;
      width: 100%;
      height: 30px;
      background-color: rgb(13, 99, 13);
      & > div {
        color: #fff;
        width: 202px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #eee;
        &.plot-name {
          flex: 1;
        }
        &.plot-location {
          width: 651px;
        }
        &.plot-longitude {
          width: 216px;
        }
      }
    }
  }
  .warning-main {
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    min-height: 0;
    padding: 0 45px;
    .warning-main-table {
      width: 100%;
      height: 100%;
      margin-bottom: 10px;
    }
  }
  .warning-main-confirm{
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    width: 100%;
    // button {
    //   width: 110px;
    //   height: 38px;
    //   outline: none;
    //   padding: 0;
    //   border: 1px solid #666;
    //   border-radius: 5px;
    //   cursor: pointer;
    //   margin-bottom: 5px;
    // }
    // button.warning-forecast-achieve {
    //   margin-bottom: 0;
    // }
  }
  .el-table td div .el-radio-group {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 0 26px;
    .el-radio-button {
      margin-bottom: 10px;
      /deep/ .el-radio-button__inner {
        display: block;
        border-radius: 4px;
      }
    }
  }
  .warning-main-table /deep/ .el-table .el-table__header-wrapper table th.el-table_1_column_16 {
    border-bottom: 0.06667rem solid #b6b5b5;
    border-right: 0.06667rem solid #b6b5b5;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    height: 30px;
    margin: 10px 65px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/warning-forecast/index.vue